webpackJsonp([230539012308250],{

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mfg-account_login-min-1.3a8fa4b6.png";

/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Banner = __webpack_require__(9);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _loginModule = __webpack_require__(276);
	
	var _loginModule2 = _interopRequireDefault(_loginModule);
	
	var _mfgAccount_loginMin = __webpack_require__(14);
	
	var _mfgAccount_loginMin2 = _interopRequireDefault(_mfgAccount_loginMin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Login = function Login() {
	  return _react2.default.createElement(
	    'div',
	    { className: _loginModule2.default.loginContainer },
	    _react2.default.createElement(_Banner2.default, { src: _mfgAccount_loginMin2.default }),
	    _react2.default.createElement(
	      'div',
	      { className: _loginModule2.default.section },
	      _react2.default.createElement(
	        'h2',
	        null,
	        'Account Login'
	      ),
	      _react2.default.createElement(
	        'p',
	        null,
	        'Access your account via Investor Connect\xAE. In addition to account updates, you also have access to your online documents, convenient financial tools, research, and more.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _loginModule2.default.field },
	        _react2.default.createElement(
	          'a',
	          {
	            className: _loginModule2.default.button,
	            href: 'https://www.investor-connect.com/WMConnect/ConnectWeb/signin/Signin.invoke?vlType=noyHbWEbxehrprG',
	            target: '_blank'
	          },
	          _react2.default.createElement(
	            'button',
	            { className: _loginModule2.default.submit },
	            _react2.default.createElement(
	              'span',
	              null,
	              'Go to Investor Connect'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Login;
	module.exports = exports['default'];

/***/ }),

/***/ 276:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"loginContainer":"src-pages----login-module---loginContainer----jnJz","section":"src-pages----login-module---section---4Ut-X","field":"src-pages----login-module---field---1q21D","labelWithLink":"src-pages----login-module---labelWithLink---hhpYO","checkboxField":"src-pages----login-module---checkboxField---2Z_yX","rememberUserId":"src-pages----login-module---rememberUserId---3Hu3L","button":"src-pages----login-module---button---1k8ac","submit":"src-pages----login-module---submit---1ySMq","links":"src-pages----login-module---links---3WPhK"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-login-js-0f196ea043f4d1431063.js